import uniqBy from 'lodash/uniqBy';
import isEmpty from 'lodash/isEmpty';

export const state = () => ({
  apps: [],
  app: {},
  appInstallations: [],
  appInstallation: {},
  selectedAreasOfInterest: [],
  selectedAppsPerSelectedAreaOfInterest: {},
});

export const cacheableStateKeys = [
  'selectedAreasOfInterest',
  'selectedAppsPerSelectedAreaOfInterest',
];

export const getters = {
  areasOfInterest(state) {
    return uniqBy(state.apps.map(app => ({
      name: app.category,
      icon: app.icon,
    })), 'name') || [];
  },
  appsPerSelectedAreaOfInterest(state) {
    const appsPerSelectedAreaOfInterest = {};

    state.selectedAreasOfInterest.forEach((areaOfInterest) => {
      appsPerSelectedAreaOfInterest[areaOfInterest] = state.apps.filter(app => app.category === areaOfInterest);
    });

    return appsPerSelectedAreaOfInterest;
  },
  getAppByName(state) {
    return name => state.apps.find(app => app.name === name);
  },
  getAppInstallationByName(state) {
    return name => state.appInstallations.find(appInstallation => appInstallation.name === name);
  },
  appInstalled(state) {
    return !isEmpty(state.appInstallation);
  },
};

export const mutations = {
  setApps(state, apps) {
    state.apps = apps;
  },
  setApp(state, app) {
    state.app = app;
    state.appInstallation = state.appInstallations.find(appInstallation => appInstallation.name === app.name);
  },
  setAppInstallations(state, appInstallations) {
    state.appInstallations = appInstallations;
  },
  setSelectedAreasOfInterest(state, selectedAreasOfInterest) {
    state.selectedAreasOfInterest = selectedAreasOfInterest;
  },
  setSelectedAppsPerSelectedAreaOfInterest(state, selectedAppsPerSelectedAreaOfInterest) {
    state.selectedAppsPerSelectedAreaOfInterest = selectedAppsPerSelectedAreaOfInterest;
  },
  updateApp(state) {
    state.app = state.apps.find(app => app.name === state.app?.name);
    state.appInstallation = state.appInstallations.find(appInstallation => appInstallation.name === state.app?.name);
  },
};

export const actions = {
  async loadPublicApps({ commit }) {
    const data = await this.$api.$get('/public/apps');
    commit('setApps', data);
  },
  async loadApps({ commit }) {
    const data = await this.$api.$get('/builder/apps');
    commit('setApps', data);
    return commit('updateApp');
  },
  async loadAppInstallations({ commit }) {
    const data = await this.$api.$get('/builder/app_installations');
    commit('setAppInstallations', data);
    return commit('updateApp');
  },
  async installApp({ dispatch }, app) {
    await this.$api.post('/builder/app_installations', { app });
    return dispatch('loadAppInstallations');
  },
  async installApps({ dispatch }, apps) {
    await this.$api.post('/builder/app_installations/batch', { apps });
    return dispatch('loadAppInstallations');
  },
  async installDummyData() {
    await this.$api.post('dummy_data');
  },
  async uninstallApp({ dispatch }, app) {
    await this.$api.delete(`/builder/app_installations/${app}`);
    return dispatch('loadAppInstallations');
  },
  setSelectedAreasOfInterest({ commit, dispatch }, selectedAreasOfInterest) {
    const newSelectedAppsPerSelectedAreaOfInterest = {};

    selectedAreasOfInterest.forEach((areaOfInterest) => {
      newSelectedAppsPerSelectedAreaOfInterest[areaOfInterest] = [];
    });

    dispatch('setSelectedAppsPerSelectedAreaOfInterest', newSelectedAppsPerSelectedAreaOfInterest);
    return commit('setSelectedAreasOfInterest', selectedAreasOfInterest);
  },
  setSelectedAppsPerSelectedAreaOfInterest({ commit }, selectedAppsPerSelectedAreaOfInterest) {
    return commit('setSelectedAppsPerSelectedAreaOfInterest', selectedAppsPerSelectedAreaOfInterest);
  },
};
